export interface MasterUser {
    apiKey: string;
    userId: string;
    companyId: string;
    jwt: string;
    refreshJwt: string;
    authToken: string;
    refreshToken: string;
}

export default class AuthUser {
    public apiKey: string;
    public userId: string;
    public companyId: string;
    public jwt: string;
    public refreshJwt: string;
    public masterUser?: MasterUser
    public authToken: string
    public refreshToken: string

    constructor(params: { [key: string]: any }) {
        this.apiKey = params.apiKey;
        this.userId = params.userId;
        this.companyId = params.companyId;
        this.jwt = params.jwt;
        this.refreshJwt = params.refreshJwt;
        if (params.masterUser) {
            this.masterUser = params.masterUser;   
        }
        this.authToken = params.authToken
        this.refreshToken = params.refreshToken
    }
}
